module.exports = __webpack_public_path__ + "img/intellig-find.a55456d2.png";